module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9pqDr"))).then(() => parcelRequire('5erN3'));